const buttonText = {
  available: 'buttonText.incentiveCard.reviewAndApply',
  incomplete: 'buttonText.incentiveCard.applicationIncomplete',
  applied: 'buttonText.incentiveCard.applicationSubmitted'
};

export default buttonText;
